import { atom } from 'recoil'
import { IOrganization } from '../Organizations/organizations.types'

type TSelfOrganizationAtomState = { organization: Omit<IOrganization, '_count'> }

const selfOrganizationAtom = atom<TSelfOrganizationAtomState>({
  key: 'self-organization',
  default: { organization: null },
})
export default selfOrganizationAtom
